import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex size-8" }

import AppLogoIcon from '@/components/AppLogoIcon.vue';
    import KeepersLogo from '@/components/icons/KeepersNavLogo.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'AppLogo',
  setup(__props) {

    
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(KeepersLogo, { class: "size-5" })
  ]))
}
}

})